const { site, internalName, brand, images } = window.settings
const { general, cta } = brand
const notifications = window.settings.notifications || {}
const webPush = notifications.webPush ? notifications.webPush : {}


const webManifest = {
	"name": site,
	"short_name": internalName,
	"background_color": general.backgroundColor,
	"icons": [{
		"src": images.desktopLogo,
		"type": "image/png"
	},{
		"src": images.mobileLogo,
		"type": "image/png"
	}],
	"gcm_user_visible_only": true,
	"display": "standalone",
	"gcm_sender_id": webPush.gcm_sender_id ? webPush.gcm_sender_id.toString() : null,
}

export const initializeWebWorker = () => {
	const blob = new Blob([JSON.stringify(webManifest)], {type: 'application/json'})
	const manifestURL = URL.createObjectURL(blob)
	document.querySelector('#manifest-placeholder').setAttribute('href', manifestURL);
}

export const requestUserPermission = () => {
	if(window.clevertap){
		window.clevertap.notifications.push({
			"titleText": webPush.titleText,
			"bodyText": webPush.bodyText,
			"okButtonText": webPush.okButtonText,
			"rejectButtonText": webPush.rejectButtonText,
			"okButtonColor": cta.primary.backgroundColor,
			"serviceWorkerPath": '/sw.js'
		})		
	}
}